// src/components/Flashcards/TextCard.jsx
import React, { useState } from "react";

const TextCard = ({ question, answer }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      onClick={() => setFlipped(!flipped)}
      className="relative w-64 h-40 perspective cursor-pointer"
    >
      {/* Inner Card */}
      <div
        className={`transition-transform duration-500 transform-style-preserve-3d w-full h-full ${
          flipped ? "rotate-y-180" : ""
        }`}
      >
        {/* Front Side */}
        <div className="absolute w-full h-full bg-gradient-to-br from-blue-500 to-cyan-500 text-white rounded-xl shadow-lg flex flex-col justify-center items-center backface-hidden">
          <h4 className="text-lg font-semibold mb-2">Question</h4>
          <p className="text-center text-sm px-4">{question}</p>
        </div>

        {/* Back Side */}
        <div className="absolute w-full h-full bg-white text-gray-800 rounded-xl shadow-lg flex flex-col justify-center items-center rotate-y-180 backface-hidden border border-gray-200">
          <h4 className="text-lg font-semibold text-blue-600 mb-2">Answer</h4>
          <p className="text-center text-sm px-4">{answer}</p>
        </div>
      </div>
    </div>
  );
};

export default TextCard;
